import styled from "styled-components"

export const CartWrapper = styled.div`
    height: 100%;
`
export const CartIconWrapper = styled.div`
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-size: 16px;
`
export const CartNumber = styled.div`
    position: absolute;
    top: calc(50% - 18px);
    left: 26px;
    width: 15px;
    height: 15px;
    padding-right: 2px;
    display: flex;
    justify-content: center;
    font-size: 10px;
    line-height: 15px;
    border-radius: 50%;
    background: ${(props) => props.theme.cartNumberBackground};
`


export const EmptyCartWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`
export const EmptyCartIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 50px;
    padding: 38px;
    margin: 30px 0;
    font-size: 28px;
    border: 1px solid ${(props) => props.theme.cartEmptyIconColor};
    border-radius: 50%;
    color: ${(props) => props.theme.cartEmptyIconColor};
`
export const EmptyCartText = styled.div`
    text-transform: uppercase;
    font-family: ${(props) => props.theme.openSans};
    font-weight: 600;
    font-size: 18px;
`


export const CartItemRow = styled.div<{
    removed: boolean
}>`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 12px;
    margin: 6px 0;
    border-radius: 2px;
    opacity: ${(props) => (props.removed ? 0.7 : 1)};
    background: ${(props) => props.theme.cartItemBackground};
`
export const CartItemInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    line-height: 24px;
    color: ${(props) => props.theme.cartItemInfoColor};
`
export const CartItemTitle = styled.div`
    font-family: ${(props) => props.theme.openSans};
    font-size: 16px;
    color: ${(props) => props.theme.cartItemTitleColor};
`
export const CartItemWarning = styled.div`
    color: ${(props) => props.theme.defaultErrorColor};
`
export const CartItemButton = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 46px;
    padding: 16px;
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.cartItemButtonColor};
    transition: ${(props) => props.theme.defaultTransition};
    
    & > i {
        font-size: 18px;
    }
    
    &:hover {
        color: ${(props) => props.theme.cartItemButtonHoverColor};
    }
`
export const CartPrice = styled.div`
    width: 170px;
    display: flex;
    align-items: center;
    justify-content: end;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.openSans};
    font-size: 18px;
    padding: 0 36px 0 8px;
    color: ${(props) => props.theme.cartPriceColor};
`
export const CartTotal = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: end;
    font-family: ${(props) => props.theme.openSans};
    font-size: 15px;
    margin-top: 10px;
`
export const CartTotalPrice = styled.div`
    padding: 0 46px 0 8px;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.openSans};
    font-size: 18px;
    color: ${(props) => props.theme.cartPriceColor};
`
export const CartCheckoutButtonWrapper = styled.div`
    display: flex;
    justify-content: end;
    margin-top: 10px;
`
